module.exports = __webpack_public_path__ + "static/img/oppoR17Pro.dbffb4b2.png";